// src/AssetManager/UploadErrorSnackbar.jsx
import React from 'react';
import { Snackbar, Alert } from '@mui/material';

const UploadErrorSnackbar = ({
  open,
  message,
  onClose,
  autoHideMs = 6000,
  severity = 'error',
}) => (
  <Snackbar
    key="upload-error-snackbar"
    open={open}
    autoHideDuration={autoHideMs}
    onClose={(_, reason) => {
      if (reason === 'clickaway') return;
      onClose?.();
    }}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    // ENTERPRISE: guarantee mount target + stacking
    container={() => (typeof document !== 'undefined' ? document.body : undefined)}
    disablePortal
    sx={{ zIndex: (theme) => (theme.zIndex?.modal ?? 1300) + 200 }}
  >
    <Alert
      onClose={onClose}
      severity={severity}
      variant="filled"
      sx={{ width: '100%' }}
    >
      {message}
    </Alert>
  </Snackbar>
);

export default UploadErrorSnackbar;